import { createSlice } from "@reduxjs/toolkit";
import {
  fetchElimination,
  fetchEventDetails,
  fetchLeaderboardData,
  fetchLeague,
  fetchOrderOfPlay,
  fetchParticularSportsEvents,
  fetchScoreDetails,
} from "api/sportsApiService";

import { fetchAllSports, fetchAllStateName } from "api/getAllSportsService";

const initialState = {
  sportsMainPage: null,
  orderOfPlay: null,
  currentSport: null,
  eventId: null,
  scoreDetails: null,
  orderOfPlayLoader: false,
  selectedOrderOfPlay: null,
  eliminationDetails: null,
  leaderboardData: null,
  eventDetails: null,
  leaugeData: null,
  allSportsData: null,
  allStateName: null,
};
const priorityOrder = {
  Finished: 2,
  Ongoing: 0,
  Upcoming: 1,
  "": 3,
};
const sportsSlice = createSlice({
  name: "sportsReducer",
  initialState,
  reducers: {
    setSportsMainPage: (state, action) => {
      state.sportsMainPage = action.payload;
    },
    setOrderOfPlay: (state, action) => {
      state.orderOfPlay = action.payload.sort(
        (a, b) =>
          priorityOrder[a?.status || ""] - priorityOrder[b?.status || ""]
      );
    },
    setCurrentSport: (state, action) => {
      state.currentSport = action.payload;
    },
    setEventId: (state, action) => {
      state.eventId = action.payload;
    },
    setScoreDetails: (state, action) => {
      state.scoreDetails = action.payload;
    },
    setOrderOfPlayLoader: (state, action) => {
      state.orderOfPlayLoader = action.payload;
    },
    setSelectedOrderOfPlay: (state, action) => {
      state.selectedOrderOfPlay = action.payload;
    },
    setEliminationDetails: (state, action) => {
      
      state.eliminationDetails = {
        ...action.payload,
        rounds: action?.payload?.rounds?.reduce((acc, item) => {
          if (item?.round_name === "Final") {
    
            // Ensure matches exist and are not empty
            if (!item.matches || item.matches.length === 0) {
              return [...acc, item]; // Don't create a "Winner" round if no matches
            }
    
            const match = item.matches[0]; // Safely access the first match
    
            return [
              ...acc,
              item,
              {
                ...item,
                round_name: "Winner",
                matches: [
                  {
                    ...match,
                    team:
                      item?.matches?.[0]?.won &&
                      item?.matches?.[0]?.won !== "won-won"
                        ? item?.matches?.[0]?.won ===
                          item?.matches?.[0]?.team1?.name
                          ? item?.matches[0]?.team1
                          : item?.matches[0]?.team2
                        : {
                            name: null,
                            players: null,
                          },
                    teamWon:
                      item?.matches?.[0]?.won &&
                      item?.matches?.[0]?.won !== "won-won"
                        ? item?.matches[0]?.team1
                        : null,
                    team_score:
                      match?.team1_score !== null && match?.team2_score !== null
                        ? Math.max(
                            parseInt(match?.team1_score) || 0,
                            parseInt(match?.team2_score) || 0
                          )
                        : null,
                  },
                ],
              },
            ];
          }
          return [...acc, item];
        }, []),
        bronze_medal_match: action?.payload?.bronze_medal_match
          ? {
              ...action?.payload?.bronze_medal_match,
              matches: [
                ...action?.payload?.bronze_medal_match?.matches,
                {
                  ...action?.payload?.bronze_medal_match?.matches[0],
                  team:
                  action?.payload?.bronze_medal_match?.matches[0]?.won === "Draw"
                    ? {
                        name: `${action?.payload?.bronze_medal_match?.matches[0]?.team1?.name} , ${action?.payload?.bronze_medal_match?.matches[0]?.team2?.name}`,
                        players: [
                          ...(action?.payload?.bronze_medal_match?.matches[0]?.team1?.players || []),
                          ...(action?.payload?.bronze_medal_match?.matches[0]?.team2?.players || []),
                        ],
                      }
                    : action?.payload?.bronze_medal_match?.matches[0]?.won ===
                      action?.payload?.bronze_medal_match?.matches[0]?.team1?.name
                    ? action?.payload?.bronze_medal_match?.matches[0]?.team1
                    : action?.payload?.bronze_medal_match?.matches[0]?.team2,
                
                  team_score: Math.max(
                    parseInt(
                      action?.payload?.bronze_medal_match?.matches[0]
                        ?.team1_score,
                      10
                    ),
                    parseInt(
                      action?.payload?.bronze_medal_match?.matches[0]
                        ?.team2_score,
                      10
                    )
                  ),
                },
              ],
            }
          : null,
      };
    },
    
    setLeaderboardData: (state, action) => {
      state.leaderboardData = action.payload;
    },
    setEventDetails: (state, action) => {
      state.eventDetails = action.payload;
    },
    setLeaugeData: (state, action) => {
      state.leaugeData = action.payload;
    },
    setAllSportsData: (state, action) => {
      state.allSportsData = action.payload;
    },
    setAllStateName: (state, action) => {
      state.allStateName = action.payload;
    },
  },
});

export const {
  setSportsMainPage,
  setOrderOfPlay,
  setEventId,
  setCurrentSport,
  setScoreDetails,
  setOrderOfPlayLoader,
  setSelectedOrderOfPlay,
  setEliminationDetails,
  setLeaderboardData,
  setEventDetails,
  setLeaugeData,
  setAllSportsData,
  setAllStateName,
} = sportsSlice.actions;

export const getSportsMainData = (param = "") => {
  return async (dispatch) => {
    try {
      const res = await fetchParticularSportsEvents(param);
      dispatch(setSportsMainPage(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getAllSportsData = (sportname) => {
  return async (dispatch) => {
    try {
      const res = await fetchAllSports(sportname);
      dispatch(setAllSportsData(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};
export const getAllStateName = () => {
  return async (dispatch) => {
    try {
      const res = await fetchAllStateName();
      dispatch(setAllStateName(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getOrderOfPlay = (props) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setOrderOfPlayLoader(true));
      const { sportsMainPage, eventId } = getState().sportsReducer;
      const sportId = sportsMainPage?.sport_id;
      console.log("-->sportId", sportId);
      const res = await fetchOrderOfPlay({
        sportId: props?.sId ?? sportId,
        eventId: props?.eId ?? eventId,
      });
      // console.log(res, "==>")
      const data = res?.data?.data?.sort(
        (a, b) => new Date(b?.schedule) - new Date(a?.schedule)
      );
      dispatch(setOrderOfPlay(data));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setOrderOfPlayLoader(false));
    }
  };
};

export const getScoreDetails = (param) => {
  return async (dispatch, getState) => {
    try {
      const { sportsMainPage } = getState().sportsReducer;
      const sport_id = sportsMainPage?.sport_id;
      const { eventId, matchId, sportId } = param;
      const res = await fetchScoreDetails({
        sportId: sportId ?? sport_id,
        eventId,
        matchId,
      });
      dispatch(setScoreDetails(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getEliminationDetails = (param) => {
  return async (dispatch, getState) => {
    try {
      const { sportId, eventId } = param ?? {};
      const res = await fetchElimination({ sportId, eventId });
      dispatch(setEliminationDetails(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getLeaderboardData = (param) => {
  return async (dispatch, getState) => {
    try {
      const { sportId, eventId, matchId } = param ?? {};
      const res = await fetchLeaderboardData({ sportId, eventId, matchId });
      dispatch(setLeaderboardData(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getEventDetails = (param) => {
  return async (dispatch, getState) => {
    try {
      const { sport } = param ?? {};
      const res = await fetchEventDetails({ sport });
      dispatch(setEventDetails(res?.data?.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getLeagueData = (param) => {
  return async (dispatch, getState) => {
    try {
      const { sportId, eventId } = param ?? {};
      const res = await fetchLeague({ sportId, eventId });
      dispatch(setLeaugeData(res?.data?.league));
    } catch (error) {
      console.error(error);
    }
  };
};

export default sportsSlice.reducer;
